export const MAX_IMAGE_SIZE_BYTES = 200 * 1024; // 200KB
export const MAX_CHAT_FILE_BYTES = 5 * 1024 * 1024; // 5MB

const ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/gif'];

const readFileAsDataUrl = (file: File, maxBytes: number, tooLargeMessage: string): Promise<string> => {
  return new Promise((resolve, reject) => {
    if (!ALLOWED_TYPES.includes(file.type)) {
      reject(new Error('Allowed formats: JPEG, PNG, WebP, GIF'));
      return;
    }

    if (file.size > maxBytes) {
      reject(new Error(tooLargeMessage));
      return;
    }

    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = () => reject(new Error('Error reading image'));
    reader.readAsDataURL(file);
  });
};

export const readImageAsDataUrl = (file: File): Promise<string> => {
  return readFileAsDataUrl(file, MAX_IMAGE_SIZE_BYTES, 'Image must not be larger than 200KB');
};

export const readChatImageAsDataUrl = (file: File): Promise<string> => {
  return readFileAsDataUrl(file, MAX_CHAT_FILE_BYTES, 'Attachment must not be larger than 5MB');
};
